import { ArrowRight } from 'lucide-react';
import { useBooking } from 'modules/jogador/booking/useBooking';
import { Card } from 'shared/components/ui/Card';
import { Button } from 'shared/components/ui/Button';
import { DateSelector } from 'modules/jogador/booking/components/DateSelector';
import { SlotLegend } from 'modules/jogador/booking/components/SlotLegend';
import { CourtSlotSection } from 'modules/jogador/booking/components/CourtSlotSection';
import { SplitToggle } from 'modules/jogador/booking/components/SplitToggle';
import { ARENA_NAME, SPORT_LABEL } from 'modules/jogador/booking/content';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { CourtSlotSkeleton } from 'modules/jogador/booking/components/CourtSlotSkeleton';
import { formatBRL } from 'shared/utils/format';

export function BookingPage() {
  const {
    dates,
    selectedDateId,
    setSelectedDateId,
    courts,
    isLoading,
    error,
    selectedSlot,
    selectSlot,
    splitEnabled,
    toggleSplit,
    maxPlayers,
    setMaxPlayers,
    goToCheckout,
  } = useBooking();

  return (
    <section className="mx-auto max-w-2xl px-4 py-8 pb-40">
      <h1 className="font-heading text-2xl font-bold text-ink">{ARENA_NAME}</h1>
      <p className="mt-1 text-sm text-ink-secondary">{SPORT_LABEL} · reserva de quadra</p>

      <div className="mt-6">
        <DateSelector dates={dates} selectedDateId={selectedDateId} onSelect={setSelectedDateId} />
      </div>

      <div className="mt-6">
        <SlotLegend />
      </div>

      <Card className="mt-4">
        <AsyncSection
          isLoading={isLoading}
          error={error}
          loadingLabel="Carregando quadras disponíveis..."
          skeleton={
            <>
              <CourtSlotSkeleton />
              <CourtSlotSkeleton />
              <CourtSlotSkeleton />
            </>
          }
        >
          {courts.map((court) => (
            <CourtSlotSection
              key={court.id}
              court={court}
              selectedTime={selectedSlot?.courtId === court.id ? selectedSlot.time : null}
              onSelect={selectSlot}
            />
          ))}
        </AsyncSection>
      </Card>

      <div className="mt-6">
        <SplitToggle
          enabled={splitEnabled}
          maxPlayers={maxPlayers}
          onToggle={toggleSplit}
          onMaxPlayersChange={setMaxPlayers}
        />
      </div>

      {selectedSlot && (
        <div className="fixed inset-x-0 bottom-16 border-t border-border bg-surface px-4 py-4 shadow-card">
          <div className="mx-auto flex max-w-2xl items-center justify-between">
            <div>
              <p className="text-sm text-ink-secondary">
                {selectedSlot.courtName} · {selectedSlot.time}
              </p>
              <p className="font-semibold text-ink">{formatBRL(selectedSlot.pricePerHour)}</p>
            </div>
            <Button onClick={goToCheckout}>
              Reservar
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Button>
          </div>
        </div>
      )}
    </section>
  );
}
